import { DisplayPayload } from '../constants/UserListField';
import { createMoffRakuAPIInstance } from '../api/MoffRakuAPI';
import * as MoffRakuConst from '../constants/MoffRaku';

const [isMoffRakuAPIError, moffRakuAPIInstance, moffRakuAPIErrorAction] = createMoffRakuAPIInstance();

/**
 * モフらく計画書の最終登録日を取得.
 * Componentから呼ばれる.
 * @param {string} userId
 * @param {(payload: DisplayPayload) => void} addDisplayDate
 * @param {number} intervalTimeMs
 * @returns
 */
export const getMoffRakuLastDate = (
  userId: string,
  addDisplayDate: (payload: DisplayPayload) => void,
  intervalTimeMs = 500,
) => {
  return async (dispatch: any) => {
    try {
      if (isMoffRakuAPIError) {
        return moffRakuAPIErrorAction;
      }

      // 最新の計画書作成日を取得
      if (!moffRakuAPIInstance) {
        addDisplayDate({
          user_id: userId,
          displayDate: '',
        });
        return moffRakuAPIErrorAction;
      }

      const latestDate = await moffRakuAPIInstance.getMoffRakuLastDataAPI(userId, addDisplayDate, intervalTimeMs);

      dispatch({
        type: MoffRakuConst.FINISH,
        result: { LoadedCount: 1 },
      });

      return {
        type: 'MOFF_RAKU_LAST_DATE_SUCCESS',
        result: latestDate,
      };
    } catch (error) {
      console.error('Error fetching moff raku last date:', error);
      // エラーが発生した場合でも、ローディングを止めるために空の日付を設定
      addDisplayDate({
        user_id: userId,
        displayDate: '',
      });
      dispatch({
        type: MoffRakuConst.FINISH,
        result: { LoadedCount: 1 },
      });
      return {
        type: 'MOFF_RAKU_LAST_DATE_ERROR',
        error,
      };
    }
  };
};

export type MoffRakuAction = ReturnType<typeof getMoffRakuLastDate>;
